// GLOBAL

jQuery(document).ready(function ($) {

    document.fonts.ready.then(() => {

        $( "h2:not(.custom)" ).each(function( index ) {

            var cible = $(this)

            var splitTitre = new SplitText( cible , {
                type: "lines",
                tag:'div',
                reduceWhiteSpace:true,
                linesClass: "line++"
            })

            gsap.from(splitTitre.lines, {
                opacity : 0,
                y : 20 ,
                duration : .6,
                ease: "power1.out",
                stagger : 0.1,
                scrollTrigger: {
                    trigger: cible,
                    markers: false,
                    start: "top 85%"
                }
            })


        })

    })


});


